import { fromZonedTime } from 'date-fns-tz';

/**
 * Преобразует строку даты в метку времени с учетом часового пояса
 * @example "14.07.2020 12:00", "Europe/Moscow" => 1594713600000
 */
export const dateStringToLocalTimeZone = (dateString: string, dateTimeZone?: string) => {
  if (!dateString) {
    return Date.now();
  }
  const [date, time] = dateString.split(' ');
  const [day, month, year] = date.split('.').map((i) => parseInt(i, 10));
  const dateFromString = new Date(year, month - 1, day, ...time.split(':').map((i) => parseInt(i, 10)));

  return dateTimeZone
    ? new Date(fromZonedTime(dateFromString, dateTimeZone).toISOString()).getTime()
    : dateFromString.getTime();
};
